import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Head.module.sass";
import Icon from "../../../../components/Icon";
import { useParams } from "react-router";
import { UseApi } from "../../../../hooks/use-api";
import {
	ChangeUserGroup,
	GetUserGroupList,
	SuspendUser,
} from "../../../../Services/lib/auth";
import Confirm from "../../../../components/Confirm";
import { UseDisclosure } from "../../../../hooks/use-disclosure";
import Modal from "../../../../components/Modal";
import { ToastEmitter } from "../../../../Services/assets/toast-emitter";
import Loader from "../../../../components/Loader";
import Dropdown from "../../../../components/Dropdown";
import { useUser } from "../../../../context";
import { getRandomColor, isEmpty } from "../../Table/Row";
const roles = {
	brandAdmin: "Brand admin",
	brandOperator: "Brand operator",
};

const Head = ({ onClose: close, className, data, refreshUser }) => {
	const { isOpen, onOpen, onClose } = UseDisclosure();
	const {
		isOpen: changeOpen,
		onOpen: changeOnOpen,
		onClose: changeOnClose,
	} = UseDisclosure();

	const {
		isOpen: suspendOpen,
		onOpen: suspendOnOpen,
		onClose: suspendOnClose,
	} = UseDisclosure();
	const { type } = useParams();
	const [isSuspended, setSuspended] = useState(data.isSuspended);
	const [role, setRole] = useState("");
	const [{ isLoading }, changeRole] = UseApi({
		service: ChangeUserGroup,
	});
	const [{ isLoading: suspendLoading }, suspend] = UseApi({
		service: SuspendUser,
	});

	const {
		tokens: { group },
	} = useUser();

	const [{}, getRole] = UseApi({
		service: GetUserGroupList,
	});

	const getRole_ = async () => {
		const role_ = await getRole({
			username: data.userName,
		});
		if (role_) {
			setRole(role_[0]?.userGroups[0]?.groupName || "");
		}
	};

	useEffect(() => {
		if (data && type === "staff") {
			getRole_();
		}
	}, [data]);

	const RemoveRole = async () => {
		const res = await changeRole({
			username: data.userName,
			changeGroups: [],
		});
		if (res) {
			ToastEmitter({
				msg: "User role has been successfully removed",
				type: "success",
			});
			onClose();
			refreshUser();
		}
	};

	const SuspendUser_ = async (a) => {
		const res = await suspend({
			username: data.userName,
			isSuspended: a,
		});
		if (res) {
			ToastEmitter({
				msg: `User has been successfully ${a ? "suspended" : "restored"}`,
				type: "success",
			});
			setSuspended(a);
			suspendOnClose();
			refreshUser();
		}
	};

	const ChangeRole = async () => {
		const res = await changeRole({
			username: data.userName,
			changeGroups: [role],
		});
		if (res) {
			ToastEmitter({
				msg: "User role has been successfully changed",
				type: "success",
			});
			changeOnClose();
			refreshUser();
		}
	};

	return (
		<div className={cn(styles.head, className)}>
			<div className={styles.user}>
				<div className={styles.avatar}>
					{isEmpty(data.profilePicture) ? (
						<div
							style={{
								backgroundColor: getRandomColor(),
							}}
						>
							{data.userName.substring(0, 2)}
						</div>
					) : (
						<img src={data.profilePicture} alt="Avatar" />
					)}
				</div>
				<div className={styles.details}>
					<div className={styles.man}>{data?.userName}</div>
					<a
						className={styles.line}
						href={`mailto:${data?.email}`}
						rel="noopener noreferrer"
					>
						{data?.email}
					</a>
				</div>
			</div>
			<div className={styles.btns}>
				{role !== "admin" && type === "staff" && group !== "brandOperator" && (
					<button
						onClick={onOpen}
						className={cn("button-stroke-red", styles.button)}
					>
						<span>Remove role</span>
						<Icon name="trash" size="24" />
					</button>
				)}
				<button
					onClick={suspendOnOpen}
					className={cn(
						isSuspended ? "button-stroke-green" : "button-stroke-orange",
						styles.button
					)}
				>
					<span>{isSuspended ? "Restore" : "Suspend"}</span>
				</button>
				{role !== "admin" && type === "staff" && group !== "brandOperator" && (
					<button
						onClick={changeOnOpen}
						className={cn("button", styles.button)}
					>
						<span>Change role</span>
						<Icon name="profile-circle" size="24" />
					</button>
				)}
				<Modal visible={isOpen} onClose={onClose}>
					<Confirm
						title="That action will remove all permission from the user."
						onCancel={onClose}
						onConfirm={RemoveRole}
						isLoading={isLoading}
					/>
				</Modal>
				<Modal visible={suspendOpen} onClose={suspendOnClose}>
					<Confirm
						title={
							isSuspended
								? "That action will restore user's previous rights"
								: "That action will suspend all permission from the user."
						}
						onCancel={suspendOnClose}
						onConfirm={() => SuspendUser_(!isSuspended)}
						isLoading={suspendLoading}
					/>
				</Modal>
			</div>

			{role !== "admin" && (
				<Modal visible={changeOpen} onClose={changeOnClose}>
					<div className={cn("title-red", styles.title)}>Change user role</div>
					<div className={styles.note}>Assign a role to an user</div>
					<Dropdown
						value={roles[role]}
						setValue={(e) => {
							const role__ =
								e === roles.brandAdmin
									? "brandAdmin"
									: e === roles.brandOperator
									? "brandOperator"
									: "";
							setRole(role__);
						}}
						options={[roles.brandAdmin, roles.brandOperator]}
					/>
					<div className={styles.btnsmdl}>
						<button
							onClick={ChangeRole}
							className={cn("button", styles.button, {
								disabled: isLoading || role === "",
							})}
						>
							{isLoading && <Loader className={styles.loader} />}
							<span>Confirm</span>
						</button>
						<button
							onClick={changeOnClose}
							className={cn("button button-stroke-red", styles.button, {
								disabled: isLoading,
							})}
						>
							Cancel
						</button>
					</div>
				</Modal>
			)}
		</div>
	);
};

export default Head;
